<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card-content">
        <form>
          <div class="row">
            <div class="col-md-12">
              <fg-input type="text"
                        label="Provincia"
                        v-model="user.provincia">
              </fg-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
            <fg-input type="text"
                      label="Partido"
                      v-model="user.partido">
            </fg-input>
            </div>
            <div class="col-md-6">
            <fg-input type="text"
                      label="Barrio"
                      v-model="user.barrio">
            </fg-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <fg-input type="text"
                        label="Calle"
                        v-model="user.calle">
              </fg-input>
            </div>
            <div class="col-md-6">
              <fg-input type="number"
                        label="Altura"
                        v-model="user.altura">
              </fg-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <fg-input type="text"
                        label="Piso"
                        v-model="user.piso">
              </fg-input>
            </div>
            <div class="col-md-4">
              <fg-input type="text"
                        label="Puerta"
                        v-model="user.puerta">
              </fg-input>
            </div>
            <div class="col-md-4">
              <fg-input type="number"
                        label="C.P."
                        v-model="user.cp">
              </fg-input>
            </div>
          </div>
          
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        user: {
          provincia: 'Buenos Aires',
          partido: 'Vicente Lopez',
          barrio: '',
          calle: 'San Lorenzo',
          altura: '1234',
          piso: '',
          puerta: '',
          cp: ''
        }
      }
    },
    props: {
      account: null
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// UserProps.vue?629f447a